import type {
  TimeEntryDetailPublic,
  TimeEntryTaskPublic,
  TimerDetailPublic,
} from "@common/client"

export function minutesFromSeconds(seconds: number): number {
  return Math.round(seconds / 60)
}

export function minutesOf(entries: TimeEntryDetailPublic[]): number {
  return minutesFromSeconds(
    entries.reduce((total, entry) => total + entry.duration, 0),
  )
}

export function shortTaskNumber(task: TimeEntryTaskPublic): string | null {
  const prefix = `${task.work_package_number}.`
  return task.number?.startsWith(prefix)
    ? task.number.slice(prefix.length)
    : task.number
}

export function taskReference(task: TimeEntryTaskPublic): string {
  const { number, work_package_number: workOrder } = task
  if (!number || !workOrder) return number ?? workOrder ?? ""
  const short = shortTaskNumber(task)
  if (short === number && number.startsWith(workOrder)) return number
  return `${workOrder} · ${short}`
}

export function timerLabel(timer: TimerDetailPublic): string {
  const [only, ...others] = timer.tasks
  return only && others.length === 0
    ? taskReference(only.task)
    : `${timer.tasks.length} tasks`
}
